<div class="new_product_page">
    <div class="product_page_div">
        <div class="bg-img">
            <img src="assets/img/login/new-bg.png" alt="bg-image">
        </div>
        <div class="product_login_card_div">
            <div class="product_login_card">
                <div class="card-logo">
                    <img src="assets/img/login/new_logo.png" alt="logo" />
                </div>
                <div class="card-title">
                    <h4 class="text-center">Welcome</h4>
                    <p class="text-center m-0">Please login to your account</p>
                </div>
                <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="authentication-form">
                    <div class="mb-3">
                        <!-- <label for="Username" class="form-label">Username</label> -->
                        <input type="text" formControlName="username" class="form-control" placeholder="Enter your username" [ngClass]="{ 'is-invalid': submitted && f.username.errors }" required />
                        <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
                            <div *ngIf="f.username.errors.required">Username is required</div>
                        </div>
                    </div>
                    <!-- <label for="pwd" class="form-label">Password</label> -->
                    <div class="input-group mb-3 password">
                        <input type="{{inputType}}" formControlName="password" placeholder="Enter your password" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.password.errors }" required />
    
                        <span class="input-group-text" (click)="toggleIcon()"> <i class="{{iconClass}}"></i></span>
                        <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                            <div *ngIf="f.password.errors.required">Password is required</div>
                        </div>
                    </div>
                    <div class="row mb-0">
                        <div class="col-md-5">
                            <div class="form-check mb-3">
                                <label class="form-check-label"> <input class="form-check-input" type="checkbox" name="remember" /> Remember me </label>
                            </div>
                        </div>
                        <div class="col-md-7 text-right">
                            <a [routerLink]="'/auth/forget-password'" class="text-infor">Forgot your password ?</a>
                        </div>
                    </div>
                    <button type="submit" class="btn btn-info btn-block mb-1">Login</button>
                </form>
            </div>
        </div>
        <p class="powrd-by">Designed, Developed & Powered By Amnex Infotechnologies Pvt Ltd.</p>
    </div>
</div>
<div class="container" id="bg-login" *ngIf="false">
  <div class="row">
      <div class="col-md-6 center-center">
          <img src="assets/img/login/AMNEX Logo-blue.svg" width="400" alt="login" />
      </div>
      <div class="col-md-2"></div>
      <div class="col-md-4 center-center">
          <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="font-9 py-3">
              <div class="text-center">
                  <img src="assets/img/login/MDB_LOGO.png" class="pb-4 logo" alt="login" />
                  <h3>Welcome</h3>
                  <p class="font-9 font-w">Please log into your account.</p>
              </div>

              
              <div class="text-center py-5">
                  <img src="assets/img/login/Powered by AMNEX.svg" width="110" alt="login" />
              </div>
          </form>
      </div>
  </div>
</div>
